import Vue from 'vue'
import format from 'date-fns/format'

Vue.filter('time', (value: unknown, layout = 'YYYY-MM-DD HH:mm:ss'): string => {
  if (!value) {
    return ''
  }
  const type = typeof value
  if (type === 'number' || type === 'string') {
    value = new Date(value as string)
  }
  return format(new Date(value + ''), layout)
})
